import {DatabaseCode, toDatabaseCode} from "./database-code";

export type ProductionAllocationMethod = DatabaseCode

const perSite: ProductionAllocationMethod = {
  code: 'PER_SITE',
  displayValue: {
    id: 'common.entity.productionallocationmethod.persite',
    defaultMessage: 'Per Site',
  },
};

const ticketWell: ProductionAllocationMethod = {
  code: 'TICKET_WELL',
  displayValue: {
    id: 'common.entity.productionallocationmethod.ticketwell',
    defaultMessage: 'Ticket Well',
  },
};

const disabled: ProductionAllocationMethod = {
  code: 'DISALBED',
  displayValue: {
    id: 'common.entity.productionallocationmethod.disabled',
    defaultMessage: 'Disabled',
  },
};

export const productionAllocationMethod = {
  perSite,
  ticketWell,
  disabled,
};

export const productionAllocationMethods = Object.values(productionAllocationMethod);

export const toProductionAllocationMethod = (code: string): ProductionAllocationMethod => toDatabaseCode(code, productionAllocationMethods);
export const toProductionAllocationMethodSafely = (code: string | undefined): ProductionAllocationMethod | undefined => code ? toDatabaseCode(code, productionAllocationMethods) : undefined;
